import React from 'react'
import PropTypes from 'prop-types'
import { PortalContextConsumer } from './PortalContext'

class Portal extends React.PureComponent {
  static propTypes = {
    channel: PropTypes.string.isRequired,
    portalRegistry: PropTypes.object.isRequired
  }

  constructor (props) {
    super(props)
    const { portalRegistry, channel, children } = props
    this.id = portalRegistry.registerPortal(channel, children)
  }

  componentDidUpdate () {
    const { portalRegistry, channel, children } = this.props
    portalRegistry.updatePortal(channel, this.id, children)
  }

  componentWillUnmount () {
    const { portalRegistry, channel } = this.props
    portalRegistry.unregisterPortal(channel, this.id)
  }

  render () {
    return null
  }
}

export default PortalContextConsumer(Portal)
